export enum WorkspaceItemAccess {
    GLOBAL = 'GLOBAL',
    MEMBER = 'MEMBER'
}
